<template>
  <div class="home" :style="{ background: `linear-gradient(180deg, ${homeConfig.gradientBgTop}, ${homeConfig.gradientBgBottom})` }">
    <header>
      <header-banner :bannerUrl="homeConfig.homepageHeaderImage" />
      <!-- <div class="not"><notification :routePath="notPath" /></div> -->
      <nav>
        <dl @click="toRank" id="baiduBtn">
          <dt><img src="../../assets/images/winterGame/icon1.png" /></dt>
          <dd>排行榜</dd>
        </dl>
        <dl @click="toMyTeam">
          <dt><img src="../../assets/images/winterGame/icon2.png" /></dt>
          <dd>我的战队</dd>
        </dl>
        <dl @click="toTeamRecord">
          <dt><img src="../../assets/images/winterGame/icon3.png" /></dt>
          <dd>全部学员</dd>
        </dl>
        <dl v-if="isGray" @click="toProperty">
          <dt><img src="../../assets/images/winterGame/icon4.png" /></dt>
          <dd>道具箱</dd>
        </dl>
      </nav>
      <!-- <div  class="section-game-time">7.1-8.25</div> -->
      <!--奖励入口-->
      <div v-if="showRerardEntry" class="reward-entry" :style="{ background: homeConfig.rewardBtnColor }" @click="gotoReward">
        <img class="reward-icon" src="../../assets/images/winterGame/reward_icon.png">
        <p class="reward-text">奖励</p>
      </div>
    </header>
    <section style="color: #ffffff">
      <sign-status
        v-if="isShowSignStatus"
        :year="currentYear"
        :season="currentSeason"
        :is-show="isShowSignStatus"
        :is-sign="isSign"
        :registrationStatus="registrationStatus"
        :registrationStatusTips="registrationStatusTips"
        :currentSeasonId="currentSeasonId"
        @viewSignPoster="viewSignPoster"
      />
      <bonus-banner
        v-if="cupRewardShow && false"
        :campusId="currentCampusId"
        :seasonId="currentSeasonId"
      />
    </section>
    <main>
      <section class="todayWarSituation">
        <home-title-bar
          :pkValueConfig="pkValueConfig"
          title="今日战况"
        ></home-title-bar>
        <div class="moduleWrapper 11">
          <home-all-module
            :teamInfo="teamInfo"
            :moduleData="todaySituationData"
            :gameType="gameType"
            :isToday="true"
            :isGray="isGray"
            :schedule_tag_id="schedule_tag_id"
            :homeConfig="homeConfig"
            :cupType="cupType"
            @shareClick="lookBattleReportPoster"
            @tabClick="tabClick($event, 'today')"
          ></home-all-module>
        </div>
        <div class="detail" v-if="isGray" @click="$router.push('/winterGame/daily')">查看详情 <van-icon name="arrow" /> </div>
        <!--晚间pk场-->
        <!-- <div
          v-if="false"
          class="moduleWrapper pkWrapper"
        >
        <home-night-module
          v-if="homeNightTodayShow && !ifTodayWeek"
          :moduleData="todaySituationData"
          :isToday="true"
          :pkParams="pkParams"
        ></home-night-module>
        </div> -->
      </section>

      <section v-if="yesterdaySituationData" class="todayWarSituation">
        <home-title-bar
          :pkValueConfig="pkValueConfig"
          title="昨日战绩"
          :isShowRight="true"
          :date="yesterdaySituationDateLabel"
          @selectCalendar="yesterdaySituationCalendar"
        ></home-title-bar>
        <div class="moduleWrapper">
          <home-all-module
            :moduleData="yesterdaySituationData"
            :isOver="true"
            :teamInfo="teamInfo"
            :gameType="gameType"
            :isToday="false"
            :season="currentSeason"
            :isGray="isGray"
            :schedule_tag_id="schedule_tag_id"
            :homeConfig="homeConfig"
            :cupType="cupType"
            @tabClick="tabClick($event, 'yesterday')"
            @shareClick="lookBattleReportPoster"
          ></home-all-module>
        </div>
        <!-- <div
          v-if="false"
          class="moduleWrapper pkWrapper"
        >
          <home-night-module
            v-if="homeNightYesterdayShow && !ifYesterdayyWeek && false"
            :moduleData="yesterdaySituationData"
            :isToday="false"
          ></home-night-module>
        </div> -->
      </section>

      <section
        class="todayWarSituation yesterdayStar"
        :style="{ background: `url(${homeConfig.yesterdayStarTrophy})`, backgroundSize: '80%', backgroundPosition: 'top center', backgroundRepeat: 'no-repeat' }"
      >
        <home-title-bar
          :homeConfig="homeConfig"
          :pkValueConfig="pkValueConfig"
          title="昨日之星"
          :date="yesterdayStarDateLabel"
          :isShowRight="true"
          @selectCalendar="yesterdayStarCalendar"
        ></home-title-bar>
        <template v-if="yesterdayStarDataList && yesterdayStarDataList.length > 0">
          <div v-for="(item, index) in yesterdayStarDataList" :key="index" class="moduleWrapper 11">
            <div class="bar">
              <span :style="{ background: `linear-gradient(180deg, ${homeConfig.bgGradientLeft}, ${homeConfig.bgGradientRight})` }"></span>
              <span :style="{ background: `linear-gradient(180deg, ${homeConfig.bgGradientLeft}, ${homeConfig.bgGradientRight})` }"></span>
            </div>
            <div class="yesterdayModule">
              <div 
                class="title_bg" 
                :style="{ 
                  backgroundImage: getTitleBackground(item) ? `url(${getTitleBackground(item)})` : '', 
                  backgroundSize: '100% 100%', 
                  backgroundRepeat: 'no-repeat', 
                  backgroundPosition: 'center' 
                }"
              ></div>
              <h3 class="starAutumnColor" :style="{ color: homeConfig.serviceCenterNameColor }">
                {{ teamInfo.servicePointName }}
              </h3>
              <title-bar
                :homeConfig="homeConfig"
                :title="item.type == 'top_day_service' ? '单日奖杯数最多' : '单日闯关成功奖杯数最多'"
              ></title-bar>
              <p>{{item.ymd}}</p>
              <div>
                <h2>{{ item.real_name }}</h2>
                <dl>
                  <dt>
                    {{ item.score | formatNumberFilter }}
                  </dt>
                  <dd>奖杯数</dd>
                </dl>
                <share-btn
                  id="zuorizhixing"
                  :btnColor="homeConfig.rewardBtnColor"
                  @shareClick="lookStarMemberPoster(item)"
                  title="查看海报"
                ></share-btn>
              </div>
            </div>
          </div>  
        </template>
        <template v-else>
          <div class="moduleWrapper">
            <div class="bar">
              <span :style="{ background: `linear-gradient(180deg, ${homeConfig.bgGradientLeft}, ${homeConfig.bgGradientRight})` }"></span>
              <span :style="{ background: `linear-gradient(180deg, ${homeConfig.bgGradientLeft}, ${homeConfig.bgGradientRight})` }"></span>
            </div>
            <div class="yesterdayModule">
              <div class="empty-yesterday-star">
                <div class="empty-img" :style="{ background: `url(${homeConfig.noStarStudentDefaultImg})`, backgroundSize: '100% 100%', backgroundPosition: 'center', backgroundRepeat: 'no-repeat' }"></div>
                <p class="empty-desc">昨日无人获得明星学员</p>
              </div>
            </div>
          </div>
        </template>
      </section>
    </main>
    <van-popup style="width: 100%" v-model="isShowStarMemberPopUpDialog">
      <battalionPoster
        :posterUrl="starMemberPoster.posterUrl"
        :isShow="starMemberPoster.isShow"
        :isStarMember="1"
        @OnCancelPoster="handleCancelStarMemberPoster"
      >
        <div id="starMemberPosterContainer">
          <!--老的明星学员 20240921需要调整，重新写一个-->
          <!-- <star-member
            :teamInfo="teamInfo"
            :posterData="starMemberPosterData"
            v-if="starMemberPoster.isPoster == 1"
            :officialPoster="officialPoster"
          ></star-member> -->
          <newStarMember 
            v-if="starMemberPoster.isPoster == 1"
            :teamInfo="teamInfo"
            :homePosterConfig="homePosterConfig"
            :posterData="starMemberPosterData"
            :officialPoster="officialPoster"
            ></newStarMember>
        </div>
      </battalionPoster>
    </van-popup>
    <van-popup style="width: 100%" v-model="isShowPopUpDialog">
      <battalionPoster
        :posterUrl="battleReportPoster.posterUrl"
        :isShow="battleReportPoster.isShow"
        @OnCancelPoster="handleCancelBattleReportPoster"
      >
        <div id="battleReportPosterContainer">
          <battle-report
            :teamInfo="teamInfo"
            :posterData="battleReportPosterData"
            v-if="battleReportPoster.isPoster == 1"
          >
          </battle-report>
        </div>
      </battalionPoster>
    </van-popup>

    <!--报名成功查看海报 start-->
    <van-popup style="width: 100%" v-model="signSuccessPosterVisible">
      <battalionPoster
        :posterUrl="signSuccessPoster.posterUrl"
        :isShow="signSuccessPoster.isShow"
        :isFixHeight="isFixHeight"
        @OnCancelPoster="handleCancelSignSuccessPoster"
      >
        <div id="signSuccessPosterContainer">
          <signSuccess
            :teamInfo="teamInfo"
            v-if="signSuccessPoster.isPoster == 1"
          >
          </signSuccess>
        </div>
      </battalionPoster>
    </van-popup>
    <!--报名成功查看海报 end-->
    <div class="calendar">
      <van-calendar
        :default-date="defaultDate"
        :min-date="minDate"
        :max-date="maxDate"
        :formatter="formatter"
        v-model="isCalendarShow"
        @confirm="onConfirm"
      />
    </div>
    <!-- 复活请求 -->
   <van-dialog
      v-model="reviveShow"
      title="复活请求待处理"
      @confirm="toRevive"
      show-cancel-button
      confirmButtonColor="#58ABF6"
      confirmButtonText="去处理"
      cancelButtonText="以后处理"
    >
      <div v-if="reiveList && reiveList.length>1" class="contet">
         有{{total}}名学生的复活待处理
      </div>
      <div v-else-if="reiveList && reiveList.length>0" class="contet">
          <div>{{reiveList[0].real_name }}</div>
          <div>发来了复活请求，待处理</div>
      </div>
    </van-dialog>
  </div>
</template>

<script>
import arrow from "./components/arrow.vue";
import emptyData from "./components/emptyData.vue";
import slideDownSelect from "./components/slideDownSelect.vue";
import InputBox from "./components/inputBox.vue";
import SubjectBtn from "@views/WinterGame/components/subjectBtn.vue";
import HonorRollModule from "@views/WinterGame/components/honorRollModule.vue";
import HomeTitleBar from "@views/WinterGame/components/homeTitleBar.vue";
import Tab from "@views/WinterGame/components/tab.vue";
import HomeAllModule from "@views/WinterGame/components/homeAllModule.vue";
import HomeNightModule from "@views/WinterGame/components/homeNightModule.vue";
import TitleBar from "@views/WinterGame/components/titleBar.vue";
import ShareBtn from "@views/WinterGame/components/shareBtn.vue";
import InvitePk from "@views/WinterGame/components/poster/invitePk.vue";
import battalionPoster from "@components/SquirrelCupII/battalion-poster.vue";
import { Toast } from "vant";
import html2canvas from "html2canvas";
import StarMember from "@views/WinterGame/components/poster/starMember.vue";
import newStarMember from "@views/WinterGame/components/poster/newStarMember.vue";
import BattleReport from "@views/WinterGame/components/poster/battleReport.vue";
import TeamHonor from "@views/WinterGame/components/poster/teamHonor.vue";
import Rank from "@views/WinterGame/components/poster/rank.vue";
import signSuccess from "@views/WinterGame/components/poster/signSuccess.vue";
import honorModule from "@views/WinterGame/components/honorModule.vue";
import SignStatus from "@views/WinterGame/components/signStatus.vue";
import BonusBanner from "@views/WinterGame/components/bonusBanner.vue";
import HeaderBanner from "@views/WinterGame/components/headerBanner.vue";
import Notification from "@views/WinterGame/components/notification.vue";
import { getGrayscaleByCampusId,revivependingprocessing } from "@/api/squirrelCup";
import {
  queryMatchStatus,
  todaySituation,
  yesterdaySituation,
  yesterdayStarV2,
  teamScheduleDates,
  cupReward,
  teamSchedule,
  checkRoles,
  queryseasonpersonalhome,
  queryseasonconfigbyseasonid
} from "../../api/winterGame";
import {
  format,
  formatDate,
  getGameType,
} from "@/util/util";


export default {
  computed: {
    starMember() {
      return starMember;
    },
  },
  components: {
    HeaderBanner,
    Notification,
    SignStatus,
    BonusBanner,
    honorModule,
    Rank,
    TeamHonor,
    BattleReport,
    StarMember,
    battalionPoster,
    signSuccess,
    InvitePk,
    ShareBtn,
    TitleBar,
    HomeAllModule,
    HomeNightModule,
    Tab,
    HomeTitleBar,
    HonorRollModule,
    SubjectBtn,
    InputBox,
    arrow,
    emptyData,
    slideDownSelect,
    newStarMember
  },
  data() {
    return {
      isGray: false,
      reviveShow:false, // 复活请求处理
      reiveList:[],
      officialPoster: true,
      homeNightTodayShow: true,
      homeNightYesterdayShow: true,
      ifTodayWeek: false,
      ifYesterdayyWeek: false,
      pkParams: {
        currentCampusId: "",
        seasonId: "",
        date: "",
        lastSeasonTagId: "",
      },
      defaultDate: null,
      isShowSignStatus: false, // 是否显示报名状态
      defaultYesterdayDate: "", // 默认昨天日期
      isShowPopUpDialog: false,
      isShowStarMemberPopUpDialog: false,
      isCalendarShow: false,
      starMemberPosterData: null,
      todaySituationData: null,
      yesterdaySituationData: null,
      yesterdayStarData: null,
      yesterdayStarDataList: [], // 昨日之星（含明星学员、闯关勇士）
      starMemberPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      signSuccessPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      currentUserId: 0,
      currentCampusId: 0,
      teamInfo: null,
      currentYear: 0, //当前年份
      currentSeason: "", // 当前季节
      battleReportPoster: {
        isShow: false,
        isPoster: -1,
        posterUrl: "",
      },
      battleReportPosterData: null,
      teamScheduleDatesData: [],
      yesterdayStarDate: new Date(),
      yesterdaySituationDate: new Date(),
      minDate: new Date(2023, 3, 1),
      maxDate: new Date(),
      yesterdaySituationDateLabel: "",
      yesterdayStarDateLabel: "",
      isYesterdayStarCalendar: false, // 是否是昨日之星日历
      yesterdayStarCalendarFormatterData: [], // 昨日之星日历选择器的formatter
      currentSeasonId: "", // 当前赛季id
      currentScheduleId: "", // 当前赛程id
      lastSeasonId: "", // 上一个赛季id
      lastScheduleId: "", // 上一个赛程id
      isSign: false, //是否已报名
      gameType: null,
      notPath:"/winterGame/notRecord",
      cupRewardShow:false,
         page: {
        pageIndex: 1,
        pageSize: 10,
      },
      loading: false,
      finished: false,
      reviveList: [],
      total: '',
      signSuccessPosterVisible: false,
      isFixHeight: false,
      registrationStatus: '',
      registrationStatusTips: '',
      showRerardEntry: false,
      schedule_tag_id: '',
      homeConfig: {
        gradientBgTop: '', // 背景色值 - 设置默认值
        gradientBgBottom: '', // 背景色值 - 设置默认值
        homepageHeaderImage: '',  // 首页顶部图 - 设置默认值
        rewardBtnColor: '', // 奖励按钮色值 - 设置默认值
        todayBattleBgColor: '', // 今日战况背景
        todayBattleTextColor: '', // 今日战况字色值 - 设置默认白色
        pkValueBgColorTop: '', // PK数值背景色值 - 渐变上
        pkValueBgColorBottom: '', // PK数值背景色值 - 渐变下
        teamTabSelectedColor: '', // 全部/战队选中色值 - 设置默认值
        teamTabUnselectedColor: '', // 未选中色值 - 设置默认值
        levelUpIcon: '', // 升段小图标 - 设置默认值
        levelUpBgColor: '', // 升段背景色 - 设置默认值
        levelUpButtonColor: '', // 升段查看按钮色值 - 设置默认值
        yesterdayStarTrophy: '', // 昨日之星奖杯图
        mvpStudentTitleImg: '', // MVP学员标题
        challengeWarriorTitle: '', // 单日奖杯数最多背景图片
        dailyTrophyMostBg: '', // 服务中心名字色值 - 设置默认值
        serviceCenterNameColor: '', // 服务中心名字色值 - 设置默认值
        bgGradientLeft: '', // 背景色条色值 - 设置默认值
        bgGradientRight: '', // 背景色条色值 - 设置默认值
        noStarStudentDefaultImg: '', // 无明星学员缺省图
      }, // 主页配置
      pkValueConfig: {
        todayBattleBgColor: '',
        todayBattleTextColor: ''
      },
      homePosterConfig: {
        rankingJump: '', // 排行榜跳转链接
        challengeWarriorPoster: '', // 闯关勇士海报
        mvpStudentPoster: '', // MVP学员海报
      },
      cupType: 0, // 1个人赛 2团队赛
    };
  },

  created() {
    document.title = this.$route.meta.title || "松鼠杯";
    const { campusId = 128, agentUserId = 7631 } = this.$route.query || {};
    let params = { campusId, agentUserId };
    localStorage.setItem("userInfoId", JSON.stringify(params || {}));
  },

  mounted() {
    this.setUserInfo();
    this.getGray();
    this.maxDate = this.getYesterday();
    this.yesterdaySituationDate = this.getYesterday();
    this.defaultDate = this.yesterdayStarDate = this.getYesterday();
    if (this.currentUserId) {
      this.getDefaultYesterdayDate();
      this.queryMatchStatus();

      this.yesterdaySituationDateLabel = format(this.yesterdaySituationDate);
      this.yesterdayStarDateLabel = format(this.yesterdayStarDate);
    }
    this.judgeWeek();
    this.queryRevive()
    this.checkRewardEntryRoles();
  },

  methods: {
    // 根据类型获取对应的背景图片
    getTitleBackground(item) {
      if (item.type === 'top_day_service') {
        // MVP类型使用mvpStudentTitleImg配置
        return this.homeConfig.mvpStudentTitleImg || '';
      } else {
        // 其他类型使用challengeWarriorTitle配置
        return this.homeConfig.challengeWarriorTitle || '';
      }
    },
    querySeasonPersonalHome() {
      queryseasonpersonalhome({
        param: {
          seasonTagId: this.currentSeasonId
        }
      }).then(res => {
        if (res.code == 0) {
          this.homeConfig = res.data;
          sessionStorage.setItem('homeConfig', JSON.stringify(res.data));
          const { todayBattleBgColor,todayBattleTextColor } = res.data
          this.pkValueConfig = {
            todayBattleBgColor,
            todayBattleTextColor
          }
        } else {
          Toast(res.message);
        }
      });
    },
    // 查询海报相关信息
    querySeasonConfigBySeasonId() {
      queryseasonconfigbyseasonid({
        param: {
          seasonTagId: this.currentSeasonId
        }
      }).then(res => {
        if (res.code == 0) {
          this.homePosterConfig = res.data;
          this.cupType = res.data.cupType || 0;
          const { rankingJump } = this.homePosterConfig;
          sessionStorage.setItem('rankingJump', rankingJump);
        } else {
          Toast(res.message);
        }
      });
    },
    queryRevive() {
      let pkParams = JSON.parse(localStorage.getItem("pkParams"));
      let userInfo = JSON.parse(localStorage.getItem("userInfoId"));

      let paramDat = {
        ...this.page,
        param: {
          season_id: pkParams.seasonId, //赛季ID
          agentUserId: Number(userInfo.agentUserId),
          service_id: userInfo.campusId, //服务中心ID
        },
      };
      revivependingprocessing(paramDat).then((res) => {
      this.reiveList=res.data.list
      this.total=res.data.count
      if(this.total>0){
        this.reviveShow=true
      }
      });
    },
    // 判断是否有权限看奖励入口
    checkRewardEntryRoles() {
      let campusId = JSON.parse(localStorage.getItem("userInfoId")).campusId;
      checkRoles({
        campusId:Number(campusId)
      }).then(res => {
        if (res.code == 0) {
          this.showRerardEntry = res.data;
        } else {
          Toast(res.message);
        }
      })
    },
    // 判断灰度
    getGray() {
      let campusId = JSON.parse(localStorage.getItem("userInfoId")).campusId;
      let param = {
        campusId:Number(campusId) , 
        key: 8,
      };
      getGrayscaleByCampusId({ param }).then((res) => {
        if (res.code == 0) {
          this.isGray = res.data;
        }
      });
    },
    // 去复活申请
    toRevive(){
      this.$router.push('/winterGame/revive')
    },
    // 经销商奖励发放数据
    async queryCupReward() {
      let params = {
        param: {
          campusId: this.currentCampusId,
          seasonTagId: this.currentSeasonId,
        }
      };
      let res = await cupReward(params);
      if (res.code == 0) {
        if (res.data) {
          this.cupRewardData = res.data;
          this.cupRewardShow = res.data.isShow;
        }
      } else {
        Toast(res.message);
      }
    },
    //获取指定赛季松鼠杯的状态
    async getSpecifiedMatchStats(seasonId, scheduleId) {
      let params = {
        param: {
          campusId: this.currentCampusId,
          scheduleId,
          seasonId,
        },
      };
      let res = await queryMatchStatus(params);

      if (res.code == 0) {
        let {
          teamId,
          cupName,
          warStatus,
          teamMemberStatus,
          cupStatus,
          payStatus,
          teamName,
          cupStartDate,
          cupEndDate,
          servicePointName,
          padTeamId,
          title,
          registrationStatus,
          registrationStatusTips
        } = res.data;
        cupStartDate = cupStartDate.substring(0, 10);
        cupEndDate = cupEndDate.substring(0, 10);
        this.teamInfo = {
          padTeamId,
          teamId,
          teamName,
          cupStatus,
          cupName,
          cupStartDate,
          cupEndDate,
          servicePointName,
          warStatus, // '出战状态1出战0未出战'
          teamMemberStatus, // '是否有战队成员1 有0没有'
          payStatus, // '报名状态1报名0未报名'
          seasonId,
          scheduleId,
          title,
        };
        this.registrationStatus = registrationStatus;
        this.registrationStatusTips = registrationStatusTips;
        this.currentSeasonId = seasonId;
        this.currentScheduleId = scheduleId;
        // 加载页面数据
        this.todaySituation();
        this.yesterdaySituation();
        this.yesterdayStar();
        this.teamScheduleDates();

        // localStorage.setItem("teamInfo", JSON.stringify(this.teamInfo));
      } else {
        Toast(res.message);
      }
    },
    judgeWeek() {
      let days = new Date().getDay();
      let preDays = new Date(
        Date.parse(this.yesterdaySituationDateLabel)
      ).getDay();
      if (days == 6 || days == 0) {
        this.ifTodayWeek = true;
      } else {
        this.ifTodayWeek = false;
      }
      if (preDays == 6 || preDays == 0) {
        this.ifYesterdayyWeek = true;
      } else {
        this.ifYesterdayyWeek = false;
      }
    },
    tabClick(e, data) {
      if (data == "today") {
        if (!e.isAll) {
          this.homeNightTodayShow = false;
        } else {
          this.homeNightTodayShow = true;
        }
      }
      if (data == "yesterday") {
        if (!e.isAll) {
          this.homeNightYesterdayShow = false;
        } else {
          this.homeNightYesterdayShow = true;
        }
      }
      /*this.yesterdaySituationDate = this.getYesterday();
        this.yesterdayStarDateLabel = format(this.yesterdaySituationDate);
      this.yesterdaySituation();*/
    },
    getRankUrl() {
      const BASE_URL = 'https://season-h5.classba.cn/livematchesfront/#/summer25?menu=team';
      const TEST_URL = 'https://season-h5-test.classba.cn/livematchesfront/#/summer25?menu=team';      
      const isTestEnvironment = location.port > 3000 || 
                              location.host.includes('.test') || 
                              location.host.includes('-pre');
      
      return isTestEnvironment ? `${TEST_URL}` : `${BASE_URL}`;
    },
    toRank() {
      // 直接使用配置上的跳转链接
      if (this.homePosterConfig.rankingJump) {
        location.href = this.homePosterConfig.rankingJump;
      }
    },
    getDefaultYesterdayDate() {
      this.defaultYesterdayDate = format(this.getYesterday());
    },
    getYesterday() {
      let today = new Date();
      let yesterday = new Date(today);
      yesterday.setDate(today.getDate() - 1);
      return yesterday;
    },
    yesterdaySituationCalendar() {
      this.isCalendarShow = true;
      this.isYesterdayStarCalendar = false;
    },
    yesterdayStarCalendar() {
      this.isYesterdayStarCalendar = true;
      this.isCalendarShow = true;
    },
    formatDate(date) {
      return `${date.getMonth() + 1}/${date.getDate()}`;
    },
    onConfirm(date) {
      this.isCalendarShow = false;
      //this.currentDate = date
      if (this.isYesterdayStarCalendar) {
        this.yesterdayStarDate = date;
        this.yesterdayStarDateLabel = format(date);

        this.yesterdayStar();
      } else {
        this.yesterdaySituationDate = date;
        this.yesterdaySituationDateLabel = format(date);
        this.yesterdaySituation();
        let selectedDate = format(this.yesterdaySituationDate) + " 00:00:00";
        this.setPkParams(selectedDate);
      }
      this.judgeWeek();
    },
    setUserInfo() {
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      if (userInfoId) {
        this.currentCampusId = userInfoId.campusId;
        this.currentUserId = userInfoId.agentUserId;
      } else {
        Toast("找不到参赛信息");
      }
    },
    setPkParams(t) {
      //PK所需参数CampusId、、seasonID由赛季信息接口返回、日期为控件时间
      const userInfoId = JSON.parse(localStorage.getItem("userInfoId"));
      this.pkParams.currentCampusId = userInfoId.campusId;
      if (t) {
        this.pkParams.date = t;
      } else {
        this.pkParams.date = format(this.yesterdaySituationDate) + " 00:00:00";
      }
      localStorage.setItem("pkParams", JSON.stringify(this.pkParams));
    },
    async queryMatchStatus() {
      let params = {
        param: {
          campusId: this.currentCampusId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
        },
      };
      let res = await queryMatchStatus(params);
      if (res.code == 0) {
        //TODO 这里会返回对应的赛季，实际上应该根据是否为春季赛来判断
        this.currentSeasonId = res.data.seasonTagId;
        this.pkParams.seasonId = this.currentSeasonId;
        this.pkParams.lastSeasonTagId = res.data.lastSeasonTagId;
        this.setPkParams();
        this.queryCupReward();
        this.querySeasonPersonalHome(); // 获取个人赛的前端配置首页
        this.querySeasonConfigBySeasonId(); // 获取海报相关信息
        let {
          teamId,
          cupName,
          warStatus,
          teamMemberStatus,
          cupStatus,
          payStatus,
          teamName,
          cupStartDate,
          cupEndDate,
          servicePointName,
          lastPadTeamId,
          lastScheduleTagId,
          lastSeasonTagId,
          scheduleTagId,
          padTeamId,
          title,
          signStartDate,
          signEndDate,
          officialStartDate,
          registrationStatus,
          registrationStatusTips,
        } = res.data;
        cupStartDate = cupStartDate.substring(0, 10);
        cupEndDate = cupEndDate.substring(0, 10);
        if (signStartDate && signEndDate) {
          signStartDate = signStartDate.substring(0, 10);
          signEndDate = signEndDate.substring(0, 10);
        }
        this.isSign = payStatus === 1;
        this.teamInfo = {
          padTeamId,
          teamId,
          teamName,
          cupStatus,
          cupName,
          cupStartDate,
          cupEndDate,
          servicePointName,
          warStatus, // '出战状态1出战0未出战'
          teamMemberStatus, // '是否有战队成员1 有0没有'
          payStatus, // '报名状态1报名0未报名'
          seasonId: "", //当前赛季设置为空
          scheduleId: scheduleTagId,
          seasonId: "", //当前赛季设置为空
          title,
          signStartDate,
          signEndDate,
          officialStartDate,  //正式赛开始时间
          currentSeasonId: this.currentSeasonId
        };
        let signDay = this.getDay()
        console.log(signDay, signStartDate, signEndDate);
        if (signStartDate && signEndDate && signDay >= signStartDate.replace(/-/g,'') && signDay <= signEndDate.replace(/-/g,'')) {
          this.isShowSignStatus = true;
        }

        // if (cupStatus == 1 || cupStatus == 4) { // 0-未开始、1-报名期、2-比赛中、3-已结束、4-即是报名期也是比赛期
        //   this.isShowSignStatus = true;
        // }
        // 后端cupStatus新增加了一个返回值
        // if (cupStatus < 2) {
        //   // 如果当前赛季是未开始或者报名期,页面上的数据是上一个赛季
        //   this.lastScheduleId = lastScheduleTagId;
        //   this.lastSeasonId = lastSeasonTagId;
        //   if (cupStatus === 1) {
        //     // 如果是报名期
        //     this.isShowSignStatus = true;
        //   }
        //   // 这个地方比较麻烦，如果当前赛季还未开始,我要把当前页面替换掉夏季赛，改为春季赛状态
        //   // 并且必须要等这个执行完，否则下面的 teamInfo 在存储时不准确，必须 await
        //   await this.getSpecifiedMatchStats(lastSeasonTagId, lastScheduleTagId);
        // } else {
        //   // 如果开始比赛了，加载当前赛季页面数据
        //   this.todaySituation();
        //   this.yesterdaySituation();
        //   this.yesterdayStar();
        //   this.teamScheduleDates();
        // }

        this.todaySituation();
        this.yesterdaySituation();
        this.yesterdayStar();
        this.teamScheduleDates();

        localStorage.setItem("teamInfo", JSON.stringify(this.teamInfo));
        console.log(this.teamInfo.title);
        localStorage.setItem("tempFlag", this.teamInfo.title);
        this.registrationStatus = registrationStatus;
        this.registrationStatusTips = registrationStatusTips;
      } else {
        Toast(res.message);
      }
    },
    getDay(d) {
      var d = new Date();
      var year = d.getFullYear();
      var month = d.getMonth() + 1 > 9 ? d.getMonth() + 1 : "0" + (d.getMonth() + 1);
      var day = d.getDate() > 9 ? d.getDate() : "0" + d.getDate();
      return year + "" + month + "" + day;
    },
    async teamScheduleDates() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
        },
      };
      let res = await teamScheduleDates(params);

      if (res.code == 0) {
        this.teamScheduleDatesData = res.data.map((item) => {
          return item.substring(0, 10);
        });
        // this.teamScheduleDatesData = res.data;
        localStorage.setItem(
          "teamScheduleDatesData",
          JSON.stringify(this.teamScheduleDatesData)
        );
      } else {
        Toast(res.message);
      }
    },
    //这边主要处理不可选日期的禁选变灰
    formatter(day) {
      let now = new Date(day.date);
      let year = now.getFullYear(); //得到年份
      let month = now.getMonth(); //得到月份
      let date = now.getDate(); //得到日期
      month = month + 1;
      if (month < 10) month = "0" + month;
      if (date < 10) date = "0" + date;
      const time = year + "-" + month + "-" + date; //（格式化"yyyy-MM-dd"）
      if (this.isYesterdayStarCalendar) {
        // 如果是昨日之星
        if (this.yesterdayStarCalendarFormatterData.includes(time)) {
        } else {
          day.type = "disabled";
        }
      } else {
        // 如果是昨日战绩
        if (this.teamScheduleDatesData.includes(time)) {
        } else {
          day.type = "disabled";
        }
      }

      return day;
    },
    async todaySituation() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
        },
      };
      let res = await todaySituation(params);

      if (res.code == 0) {
        this.todaySituationData = res.data;
      } else {
        Toast(res.message);
      }
    },
    async yesterdaySituation() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
          date: format(this.yesterdaySituationDate) + " 00:00:00",
        },
      };
      let res = await yesterdaySituation(params);
      if (res.code == 0) {
        /* res.data.pk_team_count = 3;
        res.data.pk_status = 1;
        res.data.evening_pk_count = 3;
        res.data.evening_pk_num = 9;*/
        this.yesterdaySituationData = res.data;
      } else {
        Toast(res.message);
      }
      let params2 = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          padTeamId: this.teamInfo.padTeamId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
        },
      };
      if (this.teamInfo.padTeamId) {
        let res2 = await teamSchedule(params2);
        if (res2.code == 0) {
          this.gameType = getGameType(res2.data?.schedule_tag_id);
          this.schedule_tag_id = res2.data?.schedule_tag_id;
          localStorage.setItem("gameType", this.gameType);
        } else {
          // Toast(res2.message);
        }
      }
    },
    async yesterdayStar() {
      let params = {
        param: {
          currentCampusId: this.currentCampusId,
          currentUserId: this.currentUserId,
          scheduleId: this.currentScheduleId,
          seasonId: this.currentSeasonId,
          date: format(this.yesterdayStarDate) + " 00:00:00",
          type: "top_day_service,top_rc_service",
          // date: '2024-09-19 00:00:00',
        },
      };
      let res = await yesterdayStarV2(params);
      if (res.code == 0) {
        const { dates, items } = res.data;
        console.log('items', items);
        this.yesterdayStarDataList = items;
        let formatterDaa = [];
        dates?.forEach((item) => {
          if (item.is_ok) {
            formatterDaa.push(item.date);
          }
        });
        this.yesterdayStarCalendarFormatterData = formatterDaa;
      } else {
        Toast(res.message);
      }
    },
    handleCancelStarMemberPoster(type) {
      this.starMemberPoster.isShow = type;
      this.isShowStarMemberPopUpDialog = false;
      this.$toast.clear();
    },
    // 分享生成图片
    lookStarMemberPoster(mvpData) {
      this.starMemberPosterData = {
        realName: mvpData.real_name,
        cupNumber: mvpData.score,
        date: mvpData.ymd,
        type: mvpData.type,
        pk_dur: this.secondsToMinutes(mvpData.pk_dur),
        ques_num: mvpData.ques_num,
        video_length: this.secondsToMinutes(mvpData.video_length),
        rc_cnt: mvpData.rc_cnt,
        score:  mvpData.score,
      };
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.isShowStarMemberPopUpDialog = true;
      this.starMemberPoster.isPoster = 1;
      setTimeout(() => {
        const targetDom = document.querySelector("#starMemberPosterContainer");
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.starMemberPoster.isShow = true;
          this.starMemberPoster.posterUrl = canvas.toDataURL();
          this.starMemberPoster.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 1000);
    },
    secondsToMinutes(seconds) {
      let result = '';
      if (seconds) {
        result = seconds / 60;
        result = result.toFixed(1);
      } else {
        result =  0
      }
      result = result.toString();
      if(result.endsWith('0')) {
        // 如果小数部分是0，则去掉小数点
        result = result.replace(/\.0$/, '');
      }
      return result;
    },
    toTeamRecord() {
      this.$router.push("/winterGame/teamRecord");
    },
    toProperty(){
      this.$router.push("/winterGame/property");
    },
    /**
     * 查看奖励
     */
     gotoReward() {
      this.$router.push("/winterGame/rewardDistributionDetails");
     },
    toMyTeam() {
      this.$router.push("/winterGame/main");
    },
    lookBattleReportPoster(data) {
      let teamStatus = 0;
      if (data.isWin) {
        teamStatus = 2;
      } else {
        teamStatus = 1;
      }
      this.battleReportPosterData = {
        date: this.yesterdaySituationDateLabel,
        cupNumber: this.yesterdaySituationData.pk_settled_team_score,
        warZone: "",
        rank: 0,
        cupWinNumber: this.yesterdaySituationData.settled_team_win_count,
        pkCount: this.yesterdaySituationData.pk_settled_team_count,
        teamStatus, //直接传进入内部处理
      };
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });

      this.battleReportPoster.isPoster = 1;
      this.isShowPopUpDialog = true;
      setTimeout(() => {
        const dom = document.querySelector("#battleReportPosterContainer");
        const targetDom = dom.firstChild;
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.battleReportPoster.isShow = true;
          this.battleReportPoster.posterUrl = canvas.toDataURL();
          this.battleReportPoster.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 1000);
    },
    handleCancelBattleReportPoster(type) {
      this.battleReportPoster.isShow = type;
      this.isShowPopUpDialog = false;
    },
    handleCancelSignSuccessPoster() {
      this.signSuccessPoster.isShow = false;
      this.signSuccessPosterVisible = false;
    },
    // 查看报名海报
    viewSignPoster() {
      Toast.loading({ message: "加载中...", forbidClick: true, duration: 0 });
      this.signSuccessPosterVisible = true;
      this.signSuccessPoster.isPoster = 1;
      setTimeout(() => {
        const targetDom = document.querySelector("#signSuccessPosterContainer");
        const config = {
          useCORS: true,
          logging: true,
          width: targetDom.offsetWidth,
          height: targetDom.offsetHeight - 4,
        };
        html2canvas(targetDom, config).then((canvas) => {
          this.signSuccessPoster.isShow = true;
          this.signSuccessPoster.posterUrl = canvas.toDataURL();
          this.signSuccessPoster.isPoster = -1;
          Toast('长按保存图片');;
        });
      }, 1000);
    }
  },
};
</script>

<style lang="less">
.van-calendar__selected-day {
  background: #58abf6;
}
.van-button--danger {
  background: #58abf6;
  border: 2px solid #58abf6;
}
</style>
<style lang="less" scoped>
.summer_2025 {
  background: linear-gradient( 180deg, #0289CB 0%, #11A3C2 100%);
  main {
    section {
      &.yesterdayStar {
        .yesterdayModule {
          .starAutumnColor {
            color: #03BAD8!important;
          }
          .title_bg {
            &.mvp {
              background: url('../../assets/images/winterGame/2025/spring/mvp_students.png') no-repeat center;
              background-size: 100% 100%;
            }
            &.warrior {
              background: url('../../assets/images/winterGame/2025/spring/challenge_warriors_title.png') no-repeat center;
              background-size: 100% 100%;
            }
          }
        }
      }
      div {
        &.moduleWrapper {
          div {
            &.bar {
              span {
                background: linear-gradient( 180deg, #6EE8FF 0%, #3B9CFF 100%)!important;
              }
            }
          }
        }
      }
    }
  }
}
.spring_2025 {
  background: linear-gradient( 180deg, #58A96E 0%, #7EB656 100%);
  main {
    section {
      &.yesterdayStar {
        .yesterdayModule {
          .starAutumnColor {
            color: #179814!important;
          }
          .title_bg {
            &.mvp {
              background: url('../../assets/images/winterGame/2025/spring/mvp_students.png') no-repeat center;
              background-size: 100% 100%;
            }
            &.warrior {
              background: url('../../assets/images/winterGame/2025/spring/challenge_warriors_title.png') no-repeat center;
              background-size: 100% 100%;
            }
          }
        }
      }
      div {
        &.moduleWrapper {
          div {
            &.bar {
              span {
                background: linear-gradient( 180deg, #0BBB20 0%, #037723 100%)!important;
              }
            }
          }
        }
      }
    }
  }
}
.winter_2025 {
  background: linear-gradient( 180deg, #669AF0 0%, #7A9AF5 100%);
  main {
    section {
      &.yesterdayStar {
        .yesterdayModule {
          .starAutumnColor {
            color: #3258FD!important;
          }
          .title_bg {
            &.mvp {
              background: url('../../assets/images/winterGame/2025/winter/mvp_students.png') no-repeat center!important;
              background-size: 100% 100%!important;
            }
            &.warrior {
              background: url('../../assets/images/winterGame/2025/winter/challenge_warriors_title.png') no-repeat center!important;
              background-size: 100% 100%!important;
            }
          }
        }
      }
      div {
        &.moduleWrapper {
          div {
            &.bar {
              span {
                background: linear-gradient( 180deg, #7C6CFF 0%, #3258FD 100%)!important;
              }
            }
          }
        }
      }
    }
  }
}
// 2024春季赛
.spring_2024 {
  background: linear-gradient( 180deg, #3A8667 0%, #3F9385 100%);
}
.summer_2024 {
  background: linear-gradient( 181deg, #098CCE 0%, #4FBAD7 100%);
}
.autumn_2024 {
  background: linear-gradient( 180deg, #9D5618 0%, #BC7131 100%);
}
// 冬季赛
.winter_2024 {
  background: linear-gradient(180deg, #238DF0 0%, #3E87F0 100%);
}
// 秋季赛
.autumn_2023 {
  background: linear-gradient(180deg, #6b3410 0%, #875c31 100%);
}
// 夏季赛
.summer_2023 {
  background: linear-gradient(180deg, #0059c7 0%, #0098ff 100%);
  //background: linear-gradient(180deg, #0250B0 0%, #0098FF 100%);
}
// 春季赛
.spring_2023 {
  background: linear-gradient(180deg, #001f6d 0%, #081f65 100%);
}

.home {
  min-height: 100vh;
  header {
    position: relative;
    img {
      width: 100%;
    }
    .honorText {
      position: absolute;
      bottom: 30px;
      left: calc(50% - 160px);
      width: 320px;
    }
    .not {
      position: absolute;
      top: 36px;
      right: 30px;
    }
    .reward-entry {
      position: absolute;
      width: 150px;
      height: 50px;
      top: 180px;
      right: 0;
      border-top-left-radius: 40px;
      border-bottom-left-radius: 40px;
      display: flex;
      align-items: center;
      .reward-icon {
        width: 48px;
        height: 56px;
        margin: -10px 10px 0;
      }
      .reward-text {
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
      }
      &.winter_2025 {
        background: #5B7AFF;
      }
      &.spring_2025 {
        background: #408B43;
      }
      &.summer_2025 {
        background: #57DFCC;
      }
    }
    .section-game-time {
      position: absolute;
      width: 210px;
      height: 40px;
      left: 50%;
      margin-left: -105px;
      top: 210px;
      background: linear-gradient( 149deg, #5BE1CC 0%, #2AC7CE 100%);
      border-radius: 20px;
      border: 2px solid #0098C3;
      font-family: PingFangSC, PingFang SC;
      font-weight: 400;
      font-size: 28px;
      color: #FFFDEE;
      line-height: 40px;
      text-align: center;
      font-style: normal;
    }
  }
  .detail {
    font-family: PingFangSC, PingFang SC;
    font-weight: 400;
    font-size: 32px;
    color: #FFFFFF;
    line-height: 44px;
    text-align: right;
    font-style: normal;
    margin: 0 48px 40px 0;
  }
  nav {
    display: flex;
    justify-content: space-around;
    align-items: center;
    margin-top: -80px;
    dl {
      display: flex;
      flex-direction: column;
      align-items: center;
      dt {
        img {
          width: 112px;
        }
      }
      dd {
        text-align: center;
        margin-left: 0;
        height: 40px;
        font-size: 28px;
        font-family: PingFangSC-Regular, PingFang SC;
        font-weight: 400;
        color: #ffffff;
        line-height: 40px;
      }
    }
  }
  main {
    section {
      div.moduleWrapper {
        position: relative;
        margin: 16px 48px 16px 48px;
        div.bar {
        position: absolute;
        top: 8px;
        left: 0;
        right: 0;
        display: flex;
        justify-content: space-between;
        span {
          display: inline-block;

          width: 16px;
          height: 14px;
          background: linear-gradient( 180deg, #0BBB20 0%, #037723 100%);

          &:first-child {
            margin-left: -16px;
            border-top-left-radius: 7px;
            border-bottom-left-radius: 7px;
          }

          &:last-child {
            margin-right: -16px;
            border-top-right-radius: 7px;
            border-bottom-right-radius: 7px;
          }
        }
      }
      }
      div.pkWrapper {
        margin-top: 20px;
      }
      &.yesterdayStarBg {
        background: url("../../assets/images/winterGame/yesterdayWinterStar.png")
          no-repeat top 20px center;
      }
      &.yesterdayStarAutumnBg {
        background: url("../../assets/images/winterGame/yesterdayAutumnStar.png")
          no-repeat top 20px center;
      }
      &.yesterdayStarSpringBg {
        background: url("../../assets/images/winterGame/yesterdayStarSpringBg.png")
          no-repeat top 20px center;
      }
      &.yesterdayStarSummerBg {
        background: url("../../assets/images/winterGame/yesterdayStarSummerBg.png")
          no-repeat top 20px center;
      }
      &.yesterdayStar {
        padding-top: 200px;
        padding-bottom: 20px;
        background-size: 80%;
        text-align: center;
        .yesterdayModule {
          background: #ffffff;
          padding: 24px 36px;
          border-radius: 8px;
          margin-bottom: 32px;
          .noRace {
            height: 66px;
            text-align: center;
            font-size: 48px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 66px;
          }
          h3 {
            margin: 0 0 8px 0;
            height: 44px;
            font-size: 32px;
            font-family: PingFangSC-Medium, PingFang SC;
            font-weight: 500;
            line-height: 44px;
          }
          .title_bg {
            width: 366px;
            height: 62px;
            margin: -36px auto 0;
            &.mvp {
              background: url('../../assets/images/winterGame/mvp_students.png') no-repeat center;
              background-size: 100% 100%;
            }
            &.warrior {
              background: url('../../assets/images/winterGame/challenge_warriors_title.png') no-repeat center;
              background-size: 100% 100%;
            }
          }
          .starAutumnColor {
            margin: 25px 0;
            color: #179814;
          }
          .starColor {
            margin: 25px 0;
            color: #569F53;
          }
          h2 {
            margin: 24px 0 16px 0;
            height: 66px;
            font-size: 48px;
            font-family: PingFangSC-Semibold, PingFang SC;
            font-weight: 600;
            color: #323232;
            line-height: 66px;
          }
          dl {
            dt {
              height: 66px;
              font-size: 48px;
              font-family: PingFangSC-Semibold, PingFang SC;
              font-weight: 600;
              color: #323232;
              line-height: 66px;
              margin-bottom: 18px;
            }
            dd {
              margin-left: 0;
              height: 40px;
              font-size: 28px;
              font-family: PingFangSC-Regular, PingFang SC;
              font-weight: 400;
              color: #68707d;
              line-height: 40px;
            }
          }
          .empty-yesterday-star {
            .empty-img {
              width: 270px;
              height: 170px;
              margin: 96px auto 24px;
              &.winter_2025 {
                background: url('../../assets/images/winterGame/2025/winter/empty_yesterday_star.png') no-repeat center center;
                background-size: 100% 100%
              }
              &.spring_2025 {
                background: url('../../assets/images/winterGame/2025/spring/empty_yesterday_star.png') no-repeat center center;
                background-size: 100% 100%
              }
              &.summer_2025 {
                background: url('../../assets/images/winterGame/2025/spring/empty_yesterday_star.png') no-repeat center center;
                background-size: 100% 100%
              }
            }
            .empty-desc {
              font-family: PingFangSC, PingFang SC;
              font-weight: 400;
              font-size: 28px;
              color: #68707D;
              line-height: 40px;
              text-align: center;
              font-style: normal;
            }
          }
        }
      }
    }
  }
  .contet{
    font-size: 28px;
    color: #323232;
    text-align: center;
margin:40px 0 64px 0 ;
  }
}
</style>
